import React, { useState, useRef, useEffect } from "react";
import { Form, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import Button from "../../../components/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Title from "../../../components/Admin/Title";
import useIsAdmin from "../../../hooks/useIsAdmin";
import ErrorPage from "../../ErrorPage";
import { useUser } from "../../../components/UserContext";
import { TeamChampionship } from "./AddAssignment";

const UploadCarImage = () => {
  const { access } = useIsAdmin();
  document.title = "LVF1 - Upload Car Image";
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const refPicture = useRef<any>(null);
  const [picture, setPicture] = useState();
  const [dataForm, setDataForm] = useState<any>();
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [championships, setChampionships] = useState<string[]>([]);
  const [data, setData] = useState<any>();

  const [selectedChampionship, setSelectedChampionship] = useState("");
  const [selectedAssignment, setSelectedAssignment] = useState("");

  useEffect(() => {
    axios
      .get(
        `${
          process.env.NODE_ENV === "development"
            ? "http://localhost:5500"
            : "https://ligavirtualf1.es:5500"
        }/api/driver/getAssignmentsNoTeams`,
      )
      .then(({ data }) => {
        setData(data);
        const uniqueChampionships: any[] = [
          ...new Set(data.map((item: any) => item.championship)),
        ];
        setChampionships(uniqueChampionships);
        setSelectedChampionship(uniqueChampionships[0]);
      })
      .catch(({ response }) => {
        console.log(response);
        throw new Error(response);
      });
  }, []);

  const inputChange = ({ target }: { target: any }) => {
    const { name, value } = target;
    setDataForm({
      ...dataForm,
      [name]: value,
    });
  };

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("assignment_code", selectedAssignment);
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);

    if (picture != null) formDataFiles.append("image", picture);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/uploadCarImage`,
          formDataFiles,
        )
        .then(() => {
          toast.success("Image uploaded successfully");
          setUploading(false);
          setValidated(false);
        })
        .catch(({ response }) => {
          toast.error("Error: Code duplicated");
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (!access) return <ErrorPage />;
  return (
    <div className="full-height padding-md app-container flex-center-top page-transition">
      <div className="form-container">
        <Title text="Upload Car Image" />
        <small className="mandatory-fields">(*) Required fields</small>
        <Form noValidate validated={validated} onSubmit={submitForm}>
          <Row className="mb-3">
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Championship (*)</Form.Label>
              <Form.Select
                name="championship"
                required
                value={selectedChampionship}
                onChange={(e: any) => {
                  setSelectedChampionship(e.target.value);
                }}
              >
                {championships.map((champ: string) => {
                  return (
                    <option value={champ} key={champ}>
                      {champ}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="6">
              <Form.Label>Assignment (*)</Form.Label>

              <Form.Select
                name="assignment"
                required
                value={selectedAssignment}
                onChange={(e: any) => {
                  setSelectedAssignment(e.target.value);
                }}
              >
                <option value="" disabled>
                  None
                </option>
                {data
                  ?.filter(
                    (assignment: any) =>
                      assignment.championship === selectedChampionship,
                  )
                  .map((assign: any) => {
                    return (
                      <option
                        value={`${assign.championship_id}_${assign.username}`}
                        key={`${assign.championship_id}_${assign.username}`}
                      >
                        {assign.username}
                      </option>
                    );
                  })}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group className="form-group" as={Col} md="12">
              <Form.Label>Car Image (*)</Form.Label>
              <Form.Control
                type="file"
                accept="image/*"
                required
                ref={refPicture}
                onChange={() => setPicture(refPicture.current.files[0])}
              />
              <Form.Control.Feedback type="invalid">
                Field required
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-center">
            {uploading ? (
              <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
            ) : (
              <Button text={"Upload Image"} type="submit" />
            )}
          </div>
        </Form>
      </div>
    </div>
  );
};

export default UploadCarImage;
